import React from 'react';
import { StyledTHead } from './styles';

export type THeadProps = React.HTMLAttributes<HTMLTableSectionElement>;

const THead: React.FC<THeadProps> = props => <StyledTHead {...props} />;

export default THead;
